import {Injectable, OnInit} from '@angular/core';
import { Auth} from 'aws-amplify';
import {BehaviorSubject, Observable} from "rxjs/index";
import {ContractInfo} from "../model/contractInfo.modal";
import {HttpClient, HttpErrorResponse, HttpHeaders} from "@angular/common/http";
import {tap} from "rxjs/operators";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";
import {environment} from "../../../environments/environment";

@Injectable()
export class AuthService {

    userData$ = new BehaviorSubject<any>( {} );
    signUpData$ = new BehaviorSubject<any>( {} );
    notification$ = new BehaviorSubject<any>( {} );
    _notification = {};


    constructor(private http: HttpClient) {
        this.userData$.subscribe(userData => {
            //console.log('User Data: '+JSON.stringify(userData));
            if(userData && userData.accessToken){
                localStorage.setItem('currentAccessToken', userData.accessToken.jwtToken);
            }
        } , e => console.log(e));
        this.fetchCurrentUserProfile();

    }

    public async isAuthenticated() {

        try{
            await Auth.currentAuthenticatedUser({
                bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            });
            return true;
        }catch(err){
            return false;
        }

    }

    public async logout() {

        try{
            const response = await Auth.signOut();
            localStorage.setItem('currentAccessToken', null);
           // console.log(response);
            return true;
        }catch(err){
            return false;
        }
    }


    //TODO: remove this method later
    public signUpAdmin(request) : Observable<ContractInfo[]>{


        // validate signup request to make sure all required info is there.

        let httpOptions = {
            headers: new HttpHeaders({
                'Content-Type':  'application/json',
                'Accept': 'application/json'
            })
        };

        return this.http.post<ContractInfo[]>( environment.apiUriPrefix + '/api/public/account', request, httpOptions)
            .pipe(
                    tap(
                    data => {
                        console.log("signUp data: ", data);
                        //publish new data to contract search data, just in case someone is listening to this events.
                        this.signUpData$.next(data);
                    },
                    err => {
                        console.log("signUp error:", err);
                        this._notification["signUpData"] = {error: err };
                        this.notification$.next(this._notification);
                    }
                )
            );
    }

    public async signIn(username, password): Promise<any>{
        return Auth.signIn(username, password);
    }

    public async signUp(request) : Promise<any> {


        // validate signup request to make sure all required info is there.
        let preValidationPassed = await this.createAccountPreValidation(request);
        if(!preValidationPassed){
            // return an error to UI.
        }

        return Auth.signUp({
            username: request.email,
            password: request.password,
            attributes: {
                email: request.email,
                name: request.name, // optional
                'dev:custom:contract_number': request.contract,
                'dev:custom:site_id': '49516' // TODO: this value should be dynamic base on the current site
                // other custom attributes
            },
            validationData: [
                new CognitoUserAttribute({Name: 'securityToken', Value: request.securityToken})
            ]
        });

    }

    public async confirmSignUp(username, code) : Promise<any> {

       return Auth.confirmSignUp(username, code, {
            // Optional. Force user confirmation irrespective of existing alias. By default set to True.
            forceAliasCreation: true
        });
    }


    public async resendSignUp(username) : Promise<any> {
        return Auth.resendSignUp(username);
    }

    private async createAccountPreValidation(request) {
        return new Promise((resolve, reject) =>{
            resolve(true);
        });
    }



    public async getCurrentUserProfile() {

        try{
            const currentUser = await Auth.currentSession();
            this.userData$.next(currentUser);
            return currentUser['idToken'].payload;
        }catch(err){
            console.log(err);
            return null;
        }

    }

    public fetchCurrentUserProfile() {

        console.log('fetching current session ....');
        Auth.currentSession()
            .then(data => {
                console.log(data);
                this.userData$.next(data);
            })
            .catch((err) => console.log(err));
    }

    public getAccessToken(){
        return localStorage.getItem('currentAccessToken');
    }



}